const Repeat = ({ height = "14px", width = "14px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height={height}
    width={width}
  >
    <path
      fill="currentColor"
      d="M6 9h20.2l-3.6-3.6L24 4l6 6-6 6-1.4-1.4 3.6-3.6H6v4H4v-4c0-1.1.9-2 2-2zM9.4 17.4 5.8 21H26v-4h2v4a2 2 0 0 1-2 2H5.8l3.6 3.6L8 28l-6-6 6-6 1.4 1.4z"
    />
    <path fill="none" d="M0 0h32v32H0z" />
  </svg>
);

export default Repeat;
